import { takeUntil } from 'rxjs';
import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { UserInfoModel } from './models/user-info.model';
import { UserLoginActivityModel } from './models/user-login-activity.model';
import { UserBankCardComponent } from './components/user-bank-card/user-bank-card.component';
import { UserInfoCardComponent } from './components/user-info-card/user-info-card.component';
import { LogoutBottomSheetComponent } from './components/logout-bottom-sheet/logout-bottom-sheet.component';
import { MaknaAuthenticationService } from '../makna-authentication/services/makna-authentication.service';
import { NgxButtonComponent } from '@digipay/ngx-button';
import { NgxIcon } from '@digipay/ngx-icon';
import { IManageProfile } from './models/manage-profile.interface';
import { BaseComponent } from '../../components/core/components/base/base.component';
import { EXPIRED_PASSWORD_ROUTE, HOME_ROUTE } from '../../data-access/constants/app-routes';
import { ProfileService } from '../../components/core/services/profile.service';
import { WealthNavigationService } from '@client-monorepo/wealth/navigation';
import { ErrorCodes } from '../../data-access/enums/error-codes';
import { UserProfileService } from './services/user-profile.service';
import { UpdateSejamComponent } from './components/update-sejam/update-sejam.component';
import { MessageService, RouteStateService } from '@client-monorepo/common/utilities';
import { NgxBottomSheetService } from '@digipay/ngx-bottom-sheet';
import { NgxCountDownComponent } from '@digipay/ngx-count-down';
import { NgxAppBarComponent } from '@digipay/ngx-app-bar';

@Component({
  selector: 'app-user-profile',
  standalone: true,
  imports: [NgxIcon, NgxButtonComponent, NgxAppBarComponent, UserBankCardComponent, UserInfoCardComponent, NgxCountDownComponent],
  templateUrl: './user-profile.component.html',
  styleUrl: './user-profile.component.scss',
})
export class UserProfileComponent extends BaseComponent implements OnInit, OnDestroy {
  user: UserInfoModel = new UserInfoModel();

  userLoginActivity: UserLoginActivityModel[] = [];
  loadingSejami: boolean;

  manageItems: IManageProfile[] = [];
  timeIsOver = true;
  sejamRateLimit: boolean;

  limitTime = 300;

  state: any;
  newFeatureAPI = true;

  private routeState = inject(RouteStateService);
  private messageService = inject(MessageService);
  private profileService = inject(ProfileService);
  private bottomSheet = inject(NgxBottomSheetService);
  private userProfileService = inject(UserProfileService);
  private navigationService = inject(WealthNavigationService);
  private maknaAuthenticationService = inject(MaknaAuthenticationService);

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.state = this.routeState.getAll();
    this.manageItems = this.userProfileService.getManagmentItems(['LOGS', 'CHANGE_PASSWORD']);
    this.maknaAuthenticationService
      .sessions()
      .pipe(takeUntil(this.destroyObservable))
      .subscribe((res) => {
        if (res?.success) {
          this.userLoginActivity = res.result.details.slice(0, 3);
        }
      });

    this.profileService.getProfile().subscribe((res) => {
      if (res?.success) {
        this.user = res.result;
      }
    });

    if (this.state?.['isSejamUpdate']) {
      if (this.state?.['updateSejamSeccess']) {
        this.messageService.showSuccessMessage('اطلاعات شما به‌‌روز رسانی شد.');
        this.profileService.getProfile().subscribe();
      }
    }
  }

  onBackHandler() {
    this.navigationService.navigate([HOME_ROUTE]);
  }

  updateSejam() {
    this.loadingSejami = true;

    if (this.newFeatureAPI) {
      this.bottomSheet.openBottomSheet(UpdateSejamComponent, {});

      const bottomSheetService = this.bottomSheet.onClose.subscribe(() => {
        bottomSheetService.unsubscribe();
        this.loadingSejami = false;
      });
    } else {
      this.profileService.updateSejamiProfile().subscribe((res) => {
        if (res?.success) {
          this.user = res.result;
          this.messageService.showSuccessMessage('اطلاعات شما به‌‌روز رسانی شد.');
        } else {
          if (res?.error?.code == ErrorCodes.RateLimited) {
            this.sejamRateLimit = true;
            this.limitTime = 300;
          }
          this.messageService.showErrorMessage(res?.error?.title);
        }
        this.loadingSejami = false;
      });
    }
  }

  logout() {
    this.bottomSheet.openBottomSheet(LogoutBottomSheetComponent, {});

    const bottomSheetService = this.bottomSheet.onClose.subscribe(() => {
      bottomSheetService.unsubscribe();
      const result = this.bottomSheet.outputData();

      if (result) {
        // ? remove localstorage
        this.maknaAuthenticationService.revoke().subscribe((res) => {
          if (res?.success) {
            window.open(window.location.origin, '_self');
          }
        });
      }
    });
  }

  goto(route: string) {
    if (route === EXPIRED_PASSWORD_ROUTE) {
      this.navigationService.navigateWithQueryParams([route], {
        queryParams: { type: 'changePassword' },
      });
    } else {
      this.navigationService.navigate([route]);
    }
  }

  timerFinish() {
    this.timeIsOver = true;
    this.sejamRateLimit = false;
    localStorage.removeItem('LIMIT_TIME');
  }

  timer(t: number) {
    this.limitTime = t;
  }
}
